import script from "./ConsultationWebRegistrationApplyTmsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultationWebRegistrationApplyTmsComponent.vue?vue&type=script&setup=true&lang=js"

import "./ConsultationWebRegistrationApplyTmsComponent.vue?vue&type=style&index=0&id=33dbfc98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33dbfc98"]])

export default __exports__